import { Component, OnInit } from '@angular/core';

// import { REPORTS } from '../models/reports';
import { PagerService } from '../services/pager.service';
import { GlobalService } from '../services/global.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CreateNewIllustrationComponent } from '../create-new-illustration/create-new-illustration.component';
import { BasicQuestionComponent } from '../shared/modal/basic-question/basic-question.component';

import Utils from '../shared/utility';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  private reports: any[];
  private error:string;

  private allItems: any[];
  private filteredReports: any[];
  pager: any = {};
  pagedItems: any[];

  private role: any;
  accessToDelete = Number(localStorage.getItem('roleId')) == 1 || (Number(localStorage.getItem('parentID')) == 0 && (Number(localStorage.getItem('roleId')) == 2));
  userType = Number(localStorage.getItem('roleId')) || 3;
  public hasReports: boolean = false;

  constructor(private pagerService: PagerService, public dialog: MatDialog, private globalService: GlobalService, private snackBarService: SnackBarService, private loadingService: LoadingService, public router: Router) { 
    this.getReports();
  }

  ngOnInit() {
    this.role = Number(localStorage.getItem('roleId'));
    
    // this.allItems = REPORTS;
    // this.filteredReports = REPORTS;
    // this.setPage(1);
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.filteredReports.length, page);

    // get current page of items
    this.pagedItems = this.filteredReports.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  assignCopy(){
    this.filteredReports = Object.assign([], this.allItems);
  }

  // filterItem(value){
  //     if(!value) this.assignCopy();
  //     // console.log(this.allItems);
  //     this.filteredReports = Object.assign([], this.allItems).filter(
  //       report => ((report.c.FirstName + " " + report.c.LastName).toLowerCase().includes(value.toLowerCase()))
  //     )
  //     // console.log(this.filteredReports);
  //     this.setPage(1);
  // }

  filterItem(value){
    // console.log(value);
    //console.log('reports', this.allItems);
    //if(!value) this.assignCopy();
    this.filteredReports = Object.assign([], this.allItems).filter(
      report => {
        if(value.includes(' ')){
          var newVal = value.split(' ');
          return ((report.c.FirstName).toLowerCase().includes(newVal[0].toLowerCase()) 
          && (((report.c.spouseName) ? report.c.spouseName.split(' ')[0] : "").toLowerCase().includes(newVal[1].toLowerCase()) 
          || ((report.c.LastName) ? report.c.LastName.split(' ')[0] : "").toLowerCase().includes(newVal[1].toLowerCase())))
        } else {
          return (report.c.FirstName + " " + report.c.LastName + " " + report.c.spouseName).toLowerCase().includes(value.toLowerCase()) 
          || ((report.o) ? report.o.Name : "").toLowerCase().includes(value.toLowerCase()) 
          || ((report.a) ? report.a.FirstName + " " + report.a.LastName : "").toLowerCase().includes(value.toLowerCase()
          || (report.r.ReportID.toString() == value))
          || ((report.r) ? report.r.ReportID: "").toString().includes(value)
        }
      }
    );
    
    if (!this.filteredReports.length) {
      this.pagedItems = [];
    } else {
      this.setPage(1);
    }
  }

  createIllustration(){
    const dialogRef = this.dialog.open(CreateNewIllustrationComponent, {
      width: '50%',
      height: '60%',
      data: true
    });
  }

  public loading: boolean = false;
  getReports() {
    this.loadingService.isLoading(true);
    this.loading = true;
    this.globalService.getReportsData()
        .subscribe(
            reports => { 
              var allReports = [];
              this.hasReports = reports.combReports.length > 0 
              || reports.hcReports.length > 0 
              || reports.ltcReports.length > 0 
              || reports.ssReports.length > 0 
              || reports.mmtReports.length > 0
              || reports.hceReports;

              console.log('reports', reports);
              console.log('this.hasReports', this.hasReports);
              if (this.hasReports) {
                for (var type in reports) {
                  if(reports[type] == null){
                    continue;
                  }

                  reports[type].forEach((report) => {
                     
                    if (report.ss) {
                      // report.c.annualIncome = Utils.formatToCurrency(report.ic.CurrentIncome);
                      // report.c.irr = report.ic.IRR;
                      report.c.annualIncome = "120,000";
                      report.c.irr = 100;
                      report.c.spouseName = report.ss.MaritalState == 'Married' ? report.ss.FrmName1 : '';
                    } else if (report.mmt) {
                      // report.c.annualIncome = Utils.formatToCurrency(report.ic.CurrentIncome);
                      // report.c.irr = report.ic.IRR;
                      report.c.annualIncome = "120,000";
                      report.c.irr = 100;
                      report.c.spouseName = report.mmt.IncludePartner == 'True' ? report.mmt.FrmName1 : '';
                    } else if (report.hc) {
                      // report.c.annualIncome = Utils.formatToCurrency(report.ic.CurrentIncome);
                      // report.c.irr = report.ic.IRR;
                      report.c.annualIncome = "120,000";
                      report.c.irr = 100;
                      report.c.spouseName = (report.hc.FrmIncome) ? report.hc.FrmIncome.toLowerCase().includes('mfj') ? report.hc.FrmName1.includes('undefined') ? report.hc.FrmName1.replace('undefined', '') : report.hc.FrmName1 : '' : '';
                    } else if (report.ltc) {
                      // report.c.annualIncome = Utils.formatToCurrency(report.ic.CurrentIncome);
                      // report.c.irr = report.ic.IRR;
                      report.c.annualIncome = "120,000";
                      report.c.irr = 100;
                      report.c.spouseName = report.ltc.FrmHasPartner == 'True' ? report.ltc.FrmName1 : '';
                    } else if(report.comb){
                      //combined
                      report.c.spouseName = report.comb.FrmHasPartner == 'True' ? report.comb.FrmName1 : '';
                    }
  
                    allReports.push(report);
                  });
                }        
  
                this.reports = allReports;
  
                //console.log('reports', this.reports);
                
                // this.advisors = advisors;
                this.allItems = this.reports;
                console.log('allItems', this.allItems[0]);
  
                this.filteredReports = this.reports.sort(function(a, b) {
                  return parseInt(b.r.ID) - parseInt(a.r.ID);
                });
                
                this.setPage(1);
              }

              this.loadingService.isLoading(false);
              this.loading = false;
              // console.log(reports);
            },
            error => {
              this.error = <any>error
              this.loadingService.isLoading(false);
              this.loading = false;
            });
  }

  downloadReport(e, report) {
    // console.log(report);
    this.loadingService.isLoading(true);

    var reportID = report.r.ReportID;
    var advisorID = report.r.AdvisorID;
    var clientID = report.r.ClientID;
    var orgID = report.r.CompanyCode;
    var reportTypeID = report.r.ReportTypeID;

    // console.log(report);

    var ReportFields = { reportID, advisorID, clientID, orgID, reportTypeID, token: localStorage.getItem("bearer"), isPreviouslyDownloadedReport: true };
    this.snackBarService.add(`Downloading your ${Utils.formatReportTypeID(reportTypeID, (clientID == 0))} report`, 0);
    
    this.globalService.generateReport(ReportFields, report.c, report.r)
      .subscribe(
      resp => {
        // console.log('downloading report');
        this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error;
        this.loadingService.isLoading(false);
      });
  }

  deleteReport(e, report){
    //display popup asking if they are sure they want to delete
    const dialogRef = this.dialog.open(BasicQuestionComponent, {     
      data: { title: 'Notification!',
      btnNoTitle: 'Cancel',
      btnYesTitle: 'Delete',
      question: "Are you sure you want to delete this report?" }
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('result', result);  
      if(result){
        //display snackbar - no loading needed
        this.snackBarService.add(`Report has been permanently deleted.`, 0);

        //remove row from current list by index/ID - no need to rerun GetReports
        this.filteredReports = this.filteredReports.filter((obj) => obj.r.ReportID !== report.r.ReportID);
        this.setPage(1);

        //make call to API service to remove from DB
        var ReportID = report.r.ReportID;
        var AdvisorID = report.r.AdvisorID;
        var ClientID = report.r.ClientID;
        var CompanyCode = report.r.CompanyCode;
        var ReportTypeID = report.r.ReportTypeID;

        var ReportFields = { ReportID, AdvisorID, ClientID, CompanyCode, ReportTypeID };
        this.globalService.deleteReport(ReportFields).subscribe(
        resp => {
          //async call - dont care on the return, we filter out the items from current list on-the-fly
        },
        error => {
          this.error = <any>error;
        });
      }
    });
  }

  /* formatDate(date) {
    date = new Date(date);
    return date > 1/1/1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear() : '--';
  } */

  formatDate(date) {
    date = new Date(date);
    return date > 1 / 1 / 1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + Utils.parseDateTime(date) : '--';
  }

  formatReportTypeID(ReportTypeID: number, IsClientIDZero: boolean = false) {
    return Utils.formatReportTypeID(ReportTypeID, IsClientIDZero);
  }
 
}
